export const footerMoreLinks = {
  'eg-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://eg.wingie.com/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://eg.wingie.com/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://eg.wingie.com/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://eg.wingie.com/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://eg.wingie.com/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://eg.wingie.com/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'eg-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://eg.wingie.com/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://eg.wingie.com/en/faq/',
          title: 'Frequently Asked Questions',
        },
        {
          href: 'https://eg.wingie.com/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://eg.wingie.com/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://eg.wingie.com/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://eg.wingie.com/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'eg-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://eg.wingie.com/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://eg.wingie.com/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },
        {
          href: 'https://eg.wingie.com/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://eg.wingie.com/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://eg.wingie.com/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://eg.wingie.com/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'eg-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://eg.wingie.com/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://eg.wingie.com/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },
        {
          href: 'https://eg.wingie.com/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://eg.wingie.com/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://eg.wingie.com/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://eg.wingie.com/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'eg-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://eg.wingie.com/ru/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://eg.wingie.com/ru/faq/',
          title: 'Часто задаваемые вопросы',
        },
        {
          href: 'https://eg.wingie.com/ru/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://eg.wingie.com/ru/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://eg.wingie.com/ru/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://eg.wingie.com/ru/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'eg-it': [
    {
      title: 'Di più',
      items: [
        { title: 'Contatto', href: 'https://eg.wingie.com/it/contact/' },
        // { title: 'Domande frequenti', href: 'https://eg.wingie.com/it/faq/' },
        { title: 'Chi siamo', href: 'https://eg.wingie.com/it/about-us/' },
        { title: 'Privacy', href: 'https://eg.wingie.com/it/privacy/' },
        { title: 'Termini e condizioni', href: 'https://eg.wingie.com/it/terms-and-conditions/' },
        { title: 'I nostri premi', href: 'https://eg.wingie.com/it/awards/' },
      ],
    },
  ],
  'eg-fr': [
    {
      title: 'Plus',
      items: [
        { title: 'Contact', href: 'https://eg.wingie.com/fr/contact/' },
        // { title: 'Questions fréquemment posées', href: 'https://eg.wingie.com/fr/faq/' },
        { title: 'À propos de nous', href: 'https://eg.wingie.com/fr/about-us/' },
        { title: 'Confidentialité', href: 'https://eg.wingie.com/fr/privacy/' },
        { title: 'Termes et conditions', href: 'https://eg.wingie.com/fr/terms-and-conditions/' },
        { title: 'Nos prix', href: 'https://eg.wingie.com/fr/awards/' },
      ],
    },
  ],
  'eg-pt': [
    {
      title: 'Mais',
      items: [
        { title: 'Contato', href: 'https://eg.wingie.com/pt/contact/' },
        // { title: 'Perguntas frequentes', href: 'https://eg.wingie.com/pt/faq/' },
        { title: 'Sobre nós', href: 'https://eg.wingie.com/pt/about-us/' },
        { title: 'Privacidade', href: 'https://eg.wingie.com/pt/privacy/' },
        { title: 'Termos e condições', href: 'https://eg.wingie.com/pt/terms-and-conditions/' },
        { title: 'Nossos prêmios', href: 'https://eg.wingie.com/pt/awards/' },
      ],
    },
  ],
  'eg-ro': [
    {
      title: 'Mai multe',
      items: [
        { title: 'Contact', href: 'https://eg.wingie.com/ro/contact/' },
        // { title: 'Întrebări frecvente', href: 'https://eg.wingie.com/ro/faq/' },
        { title: 'Despre noi', href: 'https://eg.wingie.com/ro/about-us/' },
        { title: 'Confidențialitate', href: 'https://eg.wingie.com/ro/privacy/' },
        { title: 'Termeni și condiții', href: 'https://eg.wingie.com/ro/terms-and-conditions/' },
        { title: 'Premiile noastre', href: 'https://eg.wingie.com/ro/awards/' },
      ],
    },
  ],
  'eg-pl': [
    {
      title: 'Więcej',
      items: [
        { title: 'Kontakt', href: 'https://eg.wingie.com/pl/contact/' },
        // { title: 'Często zadawane pytania', href: 'https://eg.wingie.com/pl/faq/' },
        { title: 'O nas', href: 'https://eg.wingie.com/pl/about-us/' },
        { title: 'Prywatność', href: 'https://eg.wingie.com/pl/privacy/' },
        { title: 'Regulamin', href: 'https://eg.wingie.com/pl/terms-and-conditions/' },
        { title: 'Nasze nagrody', href: 'https://eg.wingie.com/pl/awards/' },
      ],
    },
  ],
  'eg-lt': [
    {
      title: 'Daugiau',
      items: [
        { title: 'Kontaktai', href: 'https://eg.wingie.com/lt/contact/' },
        // { title: 'Dažniausiai užduodami klausimai', href: 'https://eg.wingie.com/lt/faq/' },
        { title: 'Apie mus', href: 'https://eg.wingie.com/lt/about-us/' },
        { title: 'Privatumas', href: 'https://eg.wingie.com/lt/privacy/' },
        { title: 'Taisyklės ir sąlygos', href: 'https://eg.wingie.com/lt/terms-and-conditions/' },
        { title: 'Mūsų apdovanojimai', href: 'https://eg.wingie.com/lt/awards/' },
      ],
    },
  ],
  'eg-uz': [
    {
      title: "Ko'proq",
      items: [
        { title: 'Aloqa', href: 'https://eg.wingie.com/uz/contact/' },
        // { title: "Tez-tez so'raladigan savollar", href: 'https://eg.wingie.com/uz/faq/' },
        { title: 'Biz haqimizda', href: 'https://eg.wingie.com/uz/about-us/' },
        { title: 'Maxfiylik', href: 'https://eg.wingie.com/uz/privacy/' },
        { title: 'Shartlar va qoidalar', href: 'https://eg.wingie.com/uz/terms-and-conditions/' },
        { title: 'Bizning mukofotlarimiz', href: 'https://eg.wingie.com/uz/awards/' },
      ],
    },
  ],
  'eg-sr': [
    {
      title: 'Više',
      items: [
        { title: 'Kontakt', href: 'https://eg.wingie.com/sr/contact/' },
        // { title: 'Često postavljana pitanja', href: 'https://eg.wingie.com/sr/faq/' },
        { title: 'O nama', href: 'https://eg.wingie.com/sr/about-us/' },
        { title: 'Privatnost', href: 'https://eg.wingie.com/sr/privacy/' },
        { title: 'Uslovi korišćenja', href: 'https://eg.wingie.com/sr/terms-and-conditions/' },
        { title: 'Naše nagrade', href: 'https://eg.wingie.com/sr/awards/' },
      ],
    },
  ],
  'eg-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { title: 'Байланыш', href: 'https://eg.wingie.com/ky/contact/' },
        // { title: 'Көп берилүүчү суроолор', href: 'https://eg.wingie.com/ky/faq/' },
        { title: 'Біз жөнүндө', href: 'https://eg.wingie.com/ky/about-us/' },
        { title: 'Жашыруундук', href: 'https://eg.wingie.com/ky/privacy/' },
        { title: 'Шарттар жана эрежелер', href: 'https://eg.wingie.com/ky/terms-and-conditions/' },
        { title: 'Биздин сыйлыктар', href: 'https://eg.wingie.com/ky/awards/' },
      ],
    },
  ],
  'eg-tg': [
    {
      title: 'Бештар',
      items: [
        { title: 'Тамос', href: 'https://eg.wingie.com/tg/contact/' },
        // { title: 'Саволҳои зиёд пурсидашаванда', href: 'https://eg.wingie.com/tg/faq/' },
        { title: 'Дар бораи мо', href: 'https://eg.wingie.com/tg/about-us/' },
        { title: 'Махфият', href: 'https://eg.wingie.com/tg/privacy/' },
        { title: 'Шартҳо ва қоидаҳо', href: 'https://eg.wingie.com/tg/terms-and-conditions/' },
        { title: 'Мукофотҳои мо', href: 'https://eg.wingie.com/tg/awards/' },
      ],
    },
  ],
  'eg-kk': [
    {
      title: 'Көбірек',
      items: [
        { title: 'Байланыс', href: 'https://eg.wingie.com/kk/contact/' },
        // { title: 'Жиі қойылатын сұрақтар', href: 'https://eg.wingie.com/kk/faq/' },
        { title: 'Біз туралы', href: 'https://eg.wingie.com/kk/about-us/' },
        { title: 'Құпиялық', href: 'https://eg.wingie.com/kk/privacy/' },
        { title: 'Шарттар мен ережелер', href: 'https://eg.wingie.com/kk/terms-and-conditions/' },
        { title: 'Біздің марапаттарымыз', href: 'https://eg.wingie.com/kk/awards/' },
      ],
    },
  ],
  'eg-nl': [
    {
      title: 'Meer',
      items: [
        { title: 'Contact', href: 'https://eg.wingie.com/nl/contact/' },
        // { title: 'Veelgestelde vragen', href: 'https://eg.wingie.com/nl/faq/' },
        { title: 'Over ons', href: 'https://eg.wingie.com/nl/about-us/' },
        { title: 'Privacy', href: 'https://eg.wingie.com/nl/privacy/' },
        { title: 'Voorwaarden', href: 'https://eg.wingie.com/nl/terms-and-conditions/' },
        { title: 'Onze prijzen', href: 'https://eg.wingie.com/nl/awards/' },
      ],
    },
  ],
  'eg-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://eg.wingie.com/ja/contact/' },
        { title: 'よくある質問', href: 'https://eg.wingie.com/en/faq/' },
        { title: '会社概要', href: 'https://eg.wingie.com/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://eg.wingie.com/ja/privacy/' },
        { title: '利用規約', href: 'https://eg.wingie.com/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://eg.wingie.com/ja/awards/' },
      ],
    },
  ],
  'eg-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://eg.wingie.com/zh/contact/' },
        { title: '常见问题', href: 'https://eg.wingie.com/en/faq/' },
        { title: '关于我们', href: 'https://eg.wingie.com/zh/about-us/' },
        { title: '隐私政策', href: 'https://eg.wingie.com/zh/privacy/' },
        { title: '条款和条件', href: 'https://eg.wingie.com/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://eg.wingie.com/zh/awards/' },
      ],
    },
  ],
  'eg-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://eg.wingie.com/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://eg.wingie.com/en/faq/' },
        { title: '회사 소개', href: 'https://eg.wingie.com/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://eg.wingie.com/ko/privacy/' },
        { title: '이용약관', href: 'https://eg.wingie.com/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://eg.wingie.com/ko/awards/' },
      ],
    },
  ],
  'eg-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://eg.wingie.com/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://eg.wingie.com/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://eg.wingie.com/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://eg.wingie.com/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://eg.wingie.com/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://eg.wingie.com/hi/awards/' },
      ],
    },
  ],
  'eg-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://eg.wingie.com/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://eg.wingie.com/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://eg.wingie.com/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://eg.wingie.com/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://eg.wingie.com/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://eg.wingie.com/ta/awards/' },
      ],
    },
  ],
  'eg-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://eg.wingie.com/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://eg.wingie.com/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://eg.wingie.com/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://eg.wingie.com/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://eg.wingie.com/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://eg.wingie.com/th/awards/' },
      ],
    },
  ],
  'eg-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://eg.wingie.com/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://eg.wingie.com/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://eg.wingie.com/ur/about-us/' },
        { title: 'رازداری', href: 'https://eg.wingie.com/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://eg.wingie.com/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://eg.wingie.com/ur/awards/' },
      ],
    },
  ],
  'eg-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://eg.wingie.com/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://eg.wingie.com/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://eg.wingie.com/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://eg.wingie.com/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://eg.wingie.com/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://eg.wingie.com/ka/awards/' },
      ],
    },
  ],
}
